/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Admin Console
 * Mercatus Admin Console
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum LicenseType {
    ALL = 'ALL',
    SYSTEM = 'SYSTEM',
    ADMIN = 'ADMIN',
    POWER = 'POWER',
    LITE = 'LITE'
}



